export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-axis/src/identity.js
// module id = ./node_modules/d3-axis/src/identity.js
// module chunks = 54